<ng-template #FormServModel>
  <form class="form-validation" *ngIf="lang">
  <div style="width: 100% !important;">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;
    ">{{ lang?.servicing }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closepop()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="overflow: auto;">
      
      <table datatable [dtOptions]="dtOptions" class="table-striped table-sm row-border hover" id="table1">
      <thead>
        <tr>
          <th>{{ lang?.sno }}</th>
          <th>{{ lang?.description }}</th>
          <th>{{ lang?.type }}</th>
          <th>{{ lang?.matricolaNumberPlate }}</th>
          <th>{{ lang?.factoryNumber }}</th>
          <th>{{ lang?.brand }}</th>
          <th>{{ lang?.model }}</th>
          <th>{{ lang?.dateofCommissioning }}</th>
          <th>{{ lang?.location }}</th>
          <th>{{ lang?.responsible }}</th>
          <th>{{ lang?.attachments }}</th>
          <th>{{ lang?.activeorder }}</th>
          <!-- <th>{{ lang?.maintenanceStatus }}</th> -->
          <th>{{ lang?.status }}</th>
          <th>{{ lang?.photo }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of records let i = index">
          <td>{{i+1}}</td>
          <td><a [routerLink]="['/'+AppFrontRoutes.SERVICING_VIEW+'/'+record.serviceId]"
              class="blue_action">{{record.service_disp}}</a></td>
          <td>{{record.service_type}}</td>
          <td>{{record.service_no_plate}}</td>
          <td>{{record.service_fact}}</td>
          <td>{{record.service_brand}}</td>
          <td>{{record.service_model}}</td>
          <td>{{record.service_doc}}</td>
          <td>{{record.service_location}}</td>
          <td>{{ record.responsible}}</td>
          <td>
            <div *ngFor='let attach of record.service_attach.split(",")'>
              <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/servicing/{{attach}}" target="_blank">{{attach}}</a>
            </div></td>
          <td class="multi_lines_text">{{record.mplans | nl2br}}</td>
          <!-- <td class="multi_lines_text"><div [innerHTML]="record.mstatus"></div></td> -->
          <td><div [innerHTML]="record.status"></div></td>
          <td><img src="{{record.img_path}}" style="width: 50px; height: 50px;"></td>
        </tr>
      </tbody>

    </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" data-dismiss="modal" (click)="closepop()">{{ lang.close }}</button>
  </div>

</div>
</form>
</ng-template>
